import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.css'],
  imports: [
    TranslateModule,
    HeaderComponent
  ],
  standalone: true
})
export class PagenotfoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // sample code to dynamically load footer when app start
    if (document.getElementById('footerElement')) {
      document.getElementById('footerElement')?.removeAttribute('hidden');
    }
  }

}
